import styled, { keyframes } from "styled-components";
import { gradient, fadeIn, shimmer } from "./MarketplaceConstants";
export { gradient, fadeIn, shimmer };

export const SidebarLayout = styled.div`
  display: flex;
  height: calc(100vh - 64px);
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    overflow: visible;
  }
`;

export const MainContentArea = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px);
  overflow-y: auto;
  background: var(--mp-bodyBackground);

  @media (max-width: 768px) {
    height: auto;
    overflow-y: visible;
  }
`;

import marketplaceHomeBg from "../../../assets/images/marketplace/marketplace_home_bg.webp";

export const Hero = styled.section`
  width: 100%;
  box-sizing: border-box;
  background-image: url(${marketplaceHomeBg});
  background-size: cover;
  background-position: center;
  border-bottom: 1px solid var(--mp-border, rgba(23,23,23,0.07));
  padding: 80px 24px 100px;
  text-align: left;
  position: relative;
  overflow: visible;
  min-height: 480px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: var(--mp-heroOverlay, rgba(18, 20, 22, 0.55));
    pointer-events: none;
    z-index: 0;
  }

  @media (min-width: 769px) {
    padding-left: 80px;
  }

  @media (max-width: 768px) {
    padding: 48px 16px 60px;
    min-height: auto;
  }
`;

export const HeroContent = styled.div`
  max-width: 900px;
  margin: 0;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;

  @media (max-width: 768px) {
    gap: 16px;
    width: 100%;
  }
`;

export const HeroBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  height: 38px;
  padding: 8px 16px;
  gap: 12px;
  border-radius: 9999px;
  background: var(--mp-heroBadgeBg, #FFC9511A);
  border: 1px solid var(--mp-heroBadgeBorder, #FFC9514D);
  box-sizing: border-box;

  @media (max-width: 480px) {
    height: 32px;
    padding: 4px 12px;
  }
`;

export const HeroBadgeText = styled.span`
  font-family: 'Liberation Serif', serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  background: var(--mp-heroAccent, linear-gradient(95.57deg, #FFC951 0%, #C94DAA 100%));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-flex;
  align-items: center;

  span.dot {
    font-size: 24px;
    line-height: 1;
    margin-right: 6px;
    vertical-align: middle;
  }

  @media (max-width: 480px) {
    font-size: 11px;
    letter-spacing: 0.8px;
  }
`;

export const HeroTitle = styled.h1`
  margin: 0;
  font-family: 'Liberation Serif', serif;
  font-weight: 400;
  font-size: 64px;
  line-height: 70.4px;
  letter-spacing: -1.6px;
  color: var(--mp-heroHeadingColor, #E2E2E5);
  text-align: left;
  max-width: 800px;

  span.italic {
    font-style: italic;
    background: var(--mp-heroAccent, linear-gradient(95.57deg, #FFC951 0%, #C94DAA 100%));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media (max-width: 991px) {
    font-size: 48px;
    line-height: 54px;
  }

  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 38px;
    letter-spacing: -0.8px;
  }

  @media (max-width: 480px) {
    font-size: 26px;
    line-height: 32px;
  }
`;

export const HeroSub = styled.p`
  margin: 0;
  font-family: 'Liberation Serif', serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 29.25px;
  letter-spacing: 0px;
  color: var(--mp-heroSubColor, #D2C5AF);
  max-width: 680px;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 15px;
    line-height: 22px;
  }
`;

export const HeroActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  margin-top: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    gap: 12px;
    margin-top: 4px;
  }
`;

export const FindEquipmentBtn = styled.button`
  width: 220.48px;
  height: 65.5px;
  padding: 20px 40px;
  gap: 12px;
  border-radius: 9999px;
  background: var(--mp-heroBtnBg, linear-gradient(106.11deg, #FFC951 0%, #C94DAA 100%));
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Liberation Serif', serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--mp-heroBtnColor, #402D00);
  transition: all 0.2s;

  &:hover {
    transform: translateY(-2px);
    opacity: 0.95;
    box-shadow: 0 8px 24px rgba(255, 201, 81, 0.3);
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 280px;
    height: 48px;
    padding: 12px 24px;
    font-size: 14px;
  }
`;

export const HireTalentBtn = styled.button`
  width: 220.48px;
  height: 65.5px;
  padding: 20px 40px;
  gap: 12px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1.5px solid var(--mp-heroBadgeBorder, rgba(255, 255, 255, 0.35));
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Liberation Serif', serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--mp-heroHeadingColor, #E2E2E5);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-2px);
    background: rgba(255, 255, 255, 0.12);
    border-color: #ffffff;
    box-shadow: 0 8px 24px rgba(255, 255, 255, 0.15);
  }

  [data-marketplace-theme="light"] & {
    background: rgba(255, 255, 255, 0.92);
    border: 1.5px solid #C94DAA;
    color: #171717;
    box-shadow: 0 4px 16px rgba(201, 77, 170, 0.15), 0 1px 3px rgba(0, 0, 0, 0.06);

    &:hover {
      background: #ffffff;
      border-color: #C94DAA;
      color: #C94DAA;
      box-shadow: 0 8px 24px rgba(201, 77, 170, 0.25);
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 280px;
    height: 48px;
    padding: 12px 24px;
    font-size: 14px;
  }
`;

export const FeaturesSection = styled.section`
  width: 100%;
  background: var(--mp-background, #050506);
  border-top: 1px solid var(--mp-border, rgba(23, 23, 23, 0.08));
  border-bottom: 1px solid var(--mp-border, rgba(23, 23, 23, 0.08));
  padding: 64px 0;
  box-sizing: border-box;
`;

export const FeaturesGrid = styled.div`
  max-width: 1680px;
  width: 100%;
  margin: 0 auto;
  padding: 0 40px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 80px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

export const FeatureItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

export const FeatureIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FeatureIcon = styled.div<{ $maskUrl: string }>`
  width: 32px;
  height: 32px;
  background: var(--mp-iconGrad, var(--mp-heroBtnBg, linear-gradient(135deg, #FFD573 0%, #D863BA 100%)));
  mask-image: url(${props => props.$maskUrl});
  -webkit-mask-image: url(${props => props.$maskUrl});
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  display: inline-block;
`;

export const FeatureTitle = styled.h3`
  margin: 0;
  font-family: 'Liberation Serif', serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: var(--mp-headingColor, #171717);
`;

export const FeatureDesc = styled.p`
  margin: 0;
  font-family: 'Liberation Serif', serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  color: var(--mp-featureDescColor, #D2C5AF);
  opacity: 0.85;
`;

export const SearchForm = styled.form`
  display: flex;
  align-items: center;
  max-width: 760px;
  width: 100%;
  margin: 0 auto 24px;
  background: white;
  border-radius: 16px;
  padding: 6px 6px 6px 20px;
  box-shadow: 0 8px 40px rgba(201,77,170,0.18), 0 2px 12px rgba(0,0,0,0.10);
  gap: 8px;

  @media (max-width: 480px) {
    padding: 6px;
    border-radius: 12px;
    gap: 4px;
  }
`;

export const SearchIcon = styled.div`
  color: rgba(23,23,23,0.4); 
  flex-shrink: 0;
  
  @media (max-width: 480px) {
    margin-left: 8px;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 15px;
  font-family: Urbanist, sans-serif;
  color: #171717;
  background: transparent;
  min-width: 0;
  &::placeholder { color: rgba(23,23,23,0.4); }
  
  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const SearchBtn = styled.button`
  height: 42px;
  padding: 0 22px;
  border: none;
  border-radius: 10px;
  background: ${gradient};
  color: white;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 4px 14px rgba(201,77,170,0.3);
  transition: opacity 0.2s;
  &:hover { opacity: 0.9; }

  @media (max-width: 480px) {
    height: 36px;
    padding: 0 14px;
    font-size: 12px;
  }
`;

export const TypeTabs = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
  position: relative;
  z-index: 2;
  padding-bottom: 4px;
`;

export const TypeTab = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: ${p => p.$active ? "12px 24px" : "11px 23px"};
  border-radius: 100px;
  border: ${p => p.$active ? "none" : "1px solid rgba(23,23,23,0.1)"};
  background: ${p => p.$active ? gradient : "rgba(23,23,23,0.05)"};
  color: ${p => p.$active ? "white" : "rgba(23,23,23,0.75)"};
  font-family: Urbanist, sans-serif;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  outline: none;
  box-shadow: ${p => p.$active ? "0 4px 12px rgba(201, 77, 170, 0.2)" : "none"};
  transition: all 0.2s;
  &:hover { background: ${p => p.$active ? gradient : "rgba(23,23,23,0.08)"}; }
`;

export const Body = styled.div`
  width: 100%;
  max-width: 1680px;
  margin: 0 auto;
  padding: 32px 40px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 24px;
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FilterSidebar = styled.aside<{ $visible: boolean }>`
  background: white;
  border: 1px solid rgba(23,23,23,0.07);
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(23,23,23,0.04);
  display: flex;
  flex-direction: column;
  gap: 18px;
  position: sticky;
  top: 24px;

  @media (max-width: 768px) {
    display: ${p => p.$visible ? "flex" : "none"};
    position: static;
  }
`;

export const FilterHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FilterTitle = styled.div`font-size: 15px; font-weight: 800; color: #171717;`;

export const ClearBtn = styled.button`
  background: none; border: none; font-size: 12px; font-weight: 600;
  color: #c94daa; cursor: pointer; font-family: Montserrat, sans-serif;
`;

export const FilterGroup = styled.div`display: flex; flex-direction: column; gap: 7px;`;

export const FilterLabel = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px; font-weight: 700; color: rgba(23,23,23,0.5);
  text-transform: uppercase; letter-spacing: 0.04em;
`;

export const FilterSelect = styled.select`
  height: 38px; padding: 0 10px;
  border: 1px solid rgba(23,23,23,0.12); border-radius: 8px;
  font-size: 13px; font-family: Urbanist, sans-serif; background: white;
  cursor: pointer;
`;

export const FilterInput = styled.input`
  height: 38px; padding: 0 10px;
  border: 1px solid rgba(23,23,23,0.12); border-radius: 8px;
  font-size: 13px; font-family: Urbanist, sans-serif;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  &:focus { outline: none; border-color: #c94daa66; }
`;

export const PriceRow = styled.div`display: flex; align-items: center; gap: 6px;`;
export const PriceSep = styled.span`color: rgba(23,23,23,0.4); font-size: 14px;`;

export const ListingArea = styled.main`min-width: 0;`;

export const ListingTopRow = styled.div`
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 18px; gap: 12px;

  &.mobile-top-row {
    display: none;
    @media (max-width: 768px) {
      display: flex;
      margin-bottom: 0;
    }
  }

  &.desktop-top-row {
    @media (max-width: 768px) {
      display: none;
    }
  }
`;

export const ResultCount = styled.div`
  font-family: Montserrat, sans-serif; font-size: 13px; color: rgba(23,23,23,0.5); font-weight: 600;
`;

export const MobileFilterBtn = styled.button`
  display: none;
  @media (max-width: 768px) {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    border: 1px solid rgba(23,23,23,0.14);
    border-radius: 8px;
    background: white;
    font-family: Urbanist, sans-serif;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    color: rgba(23,23,23,0.7);
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 18px;

  @media (min-width: 1440px) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 24px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`;

export const SkeletonCard = styled.div`
  height: 280px;
  border-radius: 14px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 600px 100%;
  animation: ${shimmer} 1.5s infinite both;

  @media (min-width: 1440px) {
    height: 320px;
  }
`;

export const ListingCard = styled.div`
  background: white;
  border: 1px solid rgba(23,23,23,0.07);
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  animation: ${fadeIn} 0.4s ease both;
  box-shadow: 0 4px 16px rgba(23,23,23,0.04);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 36px rgba(23,23,23,0.1);
  }
`;

export const CardImage = styled.div<{ $hasImage: boolean }>`
  height: 160px;
  background: ${p => p.$hasImage ? "#f5f7fa" : "linear-gradient(135deg, #f8f4ff 0%, #f0ebff 100%)"};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  img { width: 100%; height: 100%; object-fit: contain; }

  @media (min-width: 1440px) {
    height: 200px;
  }
`;

export const PlaceholderIcon = styled.div`font-size: 48px; opacity: 0.5;`;

export const TypeLabel = styled.div<{ $color: string }>`
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 3px 9px;
  border-radius: 100px;
  font-size: 10px;
  font-weight: 700;
  font-family: Montserrat, sans-serif;
  background: ${p => p.$color};
  color: white;
  backdrop-filter: blur(6px);
`;

export const CardBody = styled.div`padding: 14px;`;

export const CardCategory = styled.div`
  display: flex; align-items: center; gap: 4px;
  font-family: Montserrat, sans-serif; font-size: 10px; font-weight: 700;
  color: rgba(23,23,23,0.4); text-transform: uppercase; letter-spacing: 0.04em;
  margin-bottom: 5px;
`;

export const CardTitle = styled.div`
  font-size: 14px; font-weight: 700; color: #171717;
  margin-bottom: 4px; line-height: 1.35;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
`;

export const CardSeller = styled.div`
  font-family: Montserrat, sans-serif; font-size: 11px; color: rgba(23,23,23,0.45); margin-bottom: 5px;
`;

export const CardLocation = styled.div`
  display: flex; align-items: center; gap: 3px;
  font-family: Montserrat, sans-serif; font-size: 11px; color: rgba(23,23,23,0.45);
  margin-bottom: 10px;
`;

export const CardFooter = styled.div`display: flex; align-items: center; justify-content: space-between;`;

export const PriceBlock = styled.div`display: flex; align-items: baseline; gap: 2px;`;
export const Price = styled.span`font-size: 16px; font-weight: 800; color: #171717;`;
export const PriceUnit = styled.span`font-size: 11px; color: rgba(23,23,23,0.45);`;

export const ViewBtn = styled.div`
  width: 30px; height: 30px; border-radius: 50%;
  background: ${gradient}; display: flex; align-items: center; justify-content: center;
  color: white; flex-shrink: 0;
`;

export const EmptyState = styled.div`text-align: center; padding: 80px 20px;`;
export const EmptyIcon = styled.div`font-size: 48px; margin-bottom: 14px;`;
export const EmptyTitle = styled.div`font-size: 18px; font-weight: 700; color: #171717; margin-bottom: 8px;`;
export const EmptyDesc = styled.div`font-family: Montserrat, sans-serif; font-size: 13px; color: rgba(23,23,23,0.45);`;

export const PaginationRow = styled.div`
  display: flex; align-items: center; justify-content: center; gap: 14px; margin-top: 28px;
`;

export const PagerBtn = styled.button`
  height: 38px; padding: 0 18px;
  border: 1px solid rgba(23,23,23,0.14); border-radius: 9px;
  background: white; color: rgba(23,23,23,0.7);
  font-family: Urbanist, sans-serif; font-size: 14px; font-weight: 600; cursor: pointer;
  &:disabled { opacity: 0.4; cursor: not-allowed; }
  &:not(:disabled):hover { background: #f5f7fa; }
`;

export const PagerInfo = styled.div`
  font-family: Montserrat, sans-serif; font-size: 13px; color: rgba(23,23,23,0.5);
`;

export const ReqList = styled.div`display: flex; flex-direction: column; gap: 10px; margin-top: 10px;`;

export const ReqCard = styled.div`
  background: white;
  border: 1px solid rgba(23,23,23,0.07);
  border-radius: 12px;
  box-shadow: 0 3px 12px rgba(23,23,23,0.04);
  overflow: hidden;
  animation: ${fadeIn} 0.3s ease;
`;

export const ReqHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  cursor: pointer;
  &:hover { background: #fafbff; }
`;

export const ReqLeft = styled.div`flex: 1;`;

export const ReqTypeBadge = styled.span<{ $type: string }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 100px;
  font-size: 10px;
  font-weight: 700;
  font-family: Montserrat, sans-serif;
  background: ${p => p.$type === "equipment_requirement" ? "#7c4dff18" : "#c94daa18"};
  color: ${p => p.$type === "equipment_requirement" ? "#7c4dff" : "#c94daa"};
  margin-bottom: 6px;
  text-transform: uppercase;
`;

export const ReqTitle = styled.div`font-size: 15px; font-weight: 700; color: #171717; margin-bottom: 6px;`;

export const ReqMeta = styled.div`display: flex; gap: 12px; flex-wrap: wrap;`;

export const MetaItem = styled.div`
  display: flex; align-items: center; gap: 4px;
  font-family: Montserrat, sans-serif; font-size: 11px; color: rgba(23,23,23,0.5);
`;

export const ReqRight = styled.div`display: flex; align-items: center; gap: 10px; flex-shrink: 0;`;

export const ReqStatusBadge = styled.span<{ $status: string }>`
  padding: 3px 10px; border-radius: 100px;
  font-size: 11px; font-weight: 700; font-family: Montserrat, sans-serif;
  background: ${p => p.$status === "active" ? "#16a34a18" : "#6b728018"};
  color: ${p => p.$status === "active" ? "#16a34a" : "#6b7280"};
  text-transform: capitalize;
`;

export const ReqDesc = styled.div`
  padding: 0 18px 14px;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: rgba(23,23,23,0.65);
  line-height: 1.6;
  border-top: 1px solid rgba(23,23,23,0.05);
  padding-top: 14px;
`;

export const ReqBody = styled.div``;

export const ReqActionRow = styled.div``;

export const ApplyBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  padding: 0 16px;
  border-radius: 8px;
  background: ${gradient};
  color: white;
  border: none;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 3px 10px rgba(201, 77, 170, 0.2);
  transition: all 0.2s;
  
  &:hover {
    opacity: 0.95;
    transform: translateY(-1px);
    box-shadow: 0 5px 14px rgba(201, 77, 170, 0.3);
  }
`;

export const PostReqCTA = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
`;

export const PostReqText = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: rgba(23, 23, 23, 0.55);
`;

export const PostReqBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 20px;
  border: none;
  border-radius: 100px;
  background: ${gradient};
  color: white;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(201, 77, 170, 0.3);
  transition: opacity 0.18s, transform 0.18s;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }
`;

export const modalSlide = keyframes`
  from { opacity: 0; transform: translateY(24px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(23, 23, 23, 0.55);
  backdrop-filter: blur(4px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const ModalBox = styled.div`
  width: 100%;
  max-width: 540px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 32px 80px rgba(23, 23, 23, 0.18);
  overflow: hidden;
  animation: ${modalSlide} 0.3s ease;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
`;

export const ModalTopBar = styled.div`
  height: 5px;
  background: ${gradient};
  flex-shrink: 0;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(23, 23, 23, 0.07);
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #171717;
`;

export const ModalClose = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: rgba(23, 23, 23, 0.06);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(23, 23, 23, 0.6);
  transition: background 0.15s;

  &:hover { background: rgba(23, 23, 23, 0.1); }
`;

export const ModalForm = styled.form`
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow-y: auto;
`;

export const MFieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const MFieldRow = styled.div`
  display: flex;
  gap: 12px;
  @media (max-width: 500px) { flex-direction: column; }
`;

export const MFieldLabel = styled.label`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: rgba(23, 23, 23, 0.45);
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const MFieldInput = styled.input`
  height: 40px;
  padding: 0 12px;
  border: 1.5px solid rgba(23, 23, 23, 0.13);
  border-radius: 9px;
  font-size: 14px;
  font-family: Urbanist, sans-serif;
  color: #171717;
  background: #fafafa;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #c94daa99;
    background: white;
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
  }
`;

export const MFieldTextarea = styled.textarea`
  padding: 10px 12px;
  border: 1.5px solid rgba(23, 23, 23, 0.13);
  border-radius: 9px;
  font-size: 14px;
  font-family: Urbanist, sans-serif;
  color: #171717;
  background: #fafafa;
  resize: none;
  width: 100%;
  box-sizing: border-box;
  line-height: 1.5;

  &:focus {
    outline: none;
    border-color: #c94daa99;
    background: white;
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
  }
`;

export const MFieldSelect = styled.select`
  height: 40px;
  padding: 0 12px;
  border: 1.5px solid rgba(23, 23, 23, 0.13);
  border-radius: 9px;
  font-size: 14px;
  font-family: Urbanist, sans-serif;
  color: #171717;
  background: #fafafa;
  cursor: pointer;
  width: 100%;

  &:focus {
    outline: none;
    border-color: #c94daa99;
  }
`;

export const ModalSubmitBtn = styled.button`
  height: 46px;
  border: none;
  border-radius: 11px;
  background: ${gradient};
  color: white;
  font-family: Urbanist, sans-serif;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(201, 77, 170, 0.25);
  transition: opacity 0.18s, transform 0.18s;
  margin-top: 4px;

  &:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const SubTabContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  border-bottom: 1.5px solid rgba(23, 23, 23, 0.06);
  padding-bottom: 8px;
`;

export const SubTabButton = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  background: ${p => p.$active ? "rgba(201, 77, 170, 0.08)" : "transparent"};
  color: ${p => p.$active ? "#c94daa" : "rgba(23, 23, 23, 0.6)"};
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 700;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${p => p.$active ? "rgba(201, 77, 170, 0.08)" : "rgba(23, 23, 23, 0.04)"};
    color: ${p => p.$active ? "#c94daa" : "#171717"};
  }
`;

export const QuoteSection = styled.section`
  padding: 60px 24px;
  max-width: 1680px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 40px 16px;
  }
`;

export const QuoteGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 24px;
  margin-top: 24px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const QuoteCard = styled.div`
  background: var(--mp-cardBackground, #ffffff);
  border: 1px solid var(--mp-border, rgba(23, 23, 23, 0.08));
  border-radius: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 32px rgba(201, 77, 170, 0.1);
    border-color: rgba(201, 77, 170, 0.3);
  }
`;

export const QuoteTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const QuoteRefBadge = styled.span`
  font-family: 'Liberation Serif', serif;
  font-size: 12px;
  font-weight: 700;
  color: #c94daa;
  background: rgba(201, 77, 170, 0.1);
  padding: 4px 10px;
  border-radius: 999px;
  letter-spacing: 0.5px;
`;

export const QuoteTypeBadge = styled.span`
  font-family: Urbanist, sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  background: var(--mp-badgeBg, rgba(255, 201, 81, 0.18));
  color: var(--mp-badgeColor, #d97706);
  padding: 4px 10px;
  border-radius: 999px;
`;

export const QuoteTitle = styled.h3`
  margin: 0;
  font-family: 'Liberation Serif', serif;
  font-size: 19px;
  font-weight: 700;
  line-height: 26px;
  color: var(--mp-headingColor, #171717);
`;

export const QuoteDesc = styled.p`
  margin: 0;
  font-family: 'Liberation Serif', serif;
  font-size: 14px;
  line-height: 22px;
  color: var(--mp-featureDescColor, #555869);
  opacity: 0.88;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const QuoteMetaGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
`;

export const QuoteMetaChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--mp-subBadgeBg, rgba(23, 23, 23, 0.04));
  border: 1px solid var(--mp-subBadgeBorder, rgba(23, 23, 23, 0.06));
  padding: 6px 12px;
  border-radius: 10px;
  font-family: Urbanist, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: var(--mp-headingColor, #171717);

  svg {
    color: #c94daa;
  }
`;

export const QuoteFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: auto;
  padding-top: 14px;
  border-top: 1px solid var(--mp-border, rgba(23, 23, 23, 0.06));
`;

export const QuoteApplyBtn = styled.button`
  flex: 1;
  padding: 10px 18px;
  border: none;
  border-radius: 12px;
  background: ${gradient};
  color: white;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(201, 77, 170, 0.25);
  transition: transform 0.18s, opacity 0.18s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  &:hover {
    transform: translateY(-1px);
    opacity: 0.95;
  }
`;

export const QuoteAppliedPill = styled.div`
  flex: 1;
  padding: 10px 18px;
  border-radius: 12px;
  background: rgba(16, 185, 129, 0.12);
  border: 1px solid rgba(16, 185, 129, 0.3);
  color: #10b981;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

export * from "./MarketplaceBrowseCardStyles";
